/** @jsx h */

import { styleguide } from 'styleguide'
import { springIn40, hash } from './utils'
import styled, { css } from 'preact-emotion'
import { h } from 'preact'
import { Divider } from './components'

const rendered = css`
  opacity: 1;
  animation: ${springIn40} 1s linear 1 normal;
  transition-delay: 120ms;
  animation-delay: 120ms;
`

const removed = css`
  transition-delay: 0ms !important;
  opacity: 0;
  pointer-events: none;
`

const Title = styled('div')`
  font-size: 28px;
  color: ${styleguide.colors.text};
  transition: all 300ms ${styleguide.timingFuncs.ease};
  opacity: 0;
  animation-fill-mode: both;
  font-family: ${props => props.font};
  font-weight: ${props => props.weight};
  margin: 0 0 ${styleguide.spacing.m};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  ${props => props.rendered && rendered};
  ${props => props.removed && removed};
  ${styleguide.mobile(
    css(`
      font-size: 18px;
    `)
  )};
`

export const titleId = `scoops-${hash('title')}`
export default function({
  style,
  className,
  theme,
  onClick,
  title,
  rendered,
  removed,
}) {
  return (
    <Title
      rendered={rendered}
      removed={removed}
      className={className}
      font={theme.titleFont}
      weight={theme.titleWeight}
      style={style}
      id={titleId}>
      <p> {title} </p>
      <Divider />
    </Title>
  )
}



// WEBPACK FOOTER //
// ../api/src/Title.jsx